export default __webpack_public_path__ + "static/media/spindex-banner-mob.b198a1d5.jpg";